import { render, staticRenderFns } from "./SearchResultsFor.vue?vue&type=template&id=2a03f38c&"
import script from "./SearchResultsFor.vue?vue&type=script&lang=js&"
export * from "./SearchResultsFor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports